import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Protected Route component that requires authentication and email verification
 * 
 * THIS IS THE SINGLE SOURCE OF TRUTH for authentication checks.
 * All protected routes should be wrapped in this component.
 * Individual components should NOT check for authentication themselves.
 * 
 * Behavior:
 * - If not logged in: Redirects to homepage with redirect parameter, which opens login modal
 * - If logged in but email not verified: Redirects to email verification page
 * - If logged in and verified: Renders the protected component
 * 
 * @param {Object} props
 * @param {React.Component} props.children - The component to render if authenticated and verified
 */
export default function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Not logged in - redirect to home with return path (login modal will open automatically)
  if (!currentUser) {
    const returnPath = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?redirect=${returnPath}`} replace />;
  }

  // Logged in but email not verified - redirect to verification required page
  if (!currentUser.emailVerified) {
    return <Navigate to="/email-verification-required" replace />;
  }

  // Logged in and verified - render the protected component
  return children;
}

